// Module
var code = "<span class=\"nc-icon-mini icon arrows-1_minimal-right\" ng-if=\"!$ctrl.isOpen\"></span><span class=\"nc-icon-mini icon arrows-1_minimal-down\" ng-if=\"$ctrl.isOpen\"></span>";
// Exports
module.exports = code;